import React from 'react';
import './index.scss';

//material-ui
import { CircularProgress, MuiThemeProvider, createMuiTheme, InputLabel, FormControl, Select, MenuItem } from '@material-ui/core';

//api
import {api} from '../../functions/api';

//custom cpomponents
import Search from '../../components/basic/search';
import CustomTable from '../../components/complex/customTable';
import CustomButton from '../../components/basic/CustomButton';
import DeleteDialog from '../../components/global/deleteDialog';

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import queryString from 'query-string'
import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'

const TIMEOUT = 3000;

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
        },
        MuiFormControl: {
            root: {
                marginLeft: "2px",
                marginRight: "5px"
            }
        },
        MuiSelect: {
            select: {
                minWidth: "100px"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class StaticPages extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            searchTerm: "",
            shop_id: "",
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.static_pages)
            && toJS(this.props.internal.user.data.permissions.static_pages.view)){

            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.HEADER.STATIC_PAGES);
            this.loadStaticPages();

            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString);

            let searchterm;
            if(queries) {
                if(queries.searchterm) {
                    searchterm = queries.searchterm
                    this.setState({searchTerm: searchterm})
                }
            }

            this.setPermissions()
        }
        else{
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    tableHeader = [
        {
            "title": "title",
            "numeric": false,
            
        },
        {
            "title": "slug",
            "numeric": false,
            textAlign: "left"
        },
        {
            "title": "is_for_shops",
            "numeric": false,
            textAlign: "left"
        },
    ];
    tableBody = ["title", "slug", "is_for_shops"]

    dropDownMenuItems = [
        
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
        //     url: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ]

    setPermissions () {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions.static_pages);

        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    url: "edit"
                },
            )
        }
        
        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                },
            )
        }

        
    }

    loadStaticPages = async (size = 10, page = 0, searchterm = " ", by = "title", dir = "asc") => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let params = {
            searchterm: searchterm,
            page: {
                number: page,
                size: size
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }

        let load_data = await api({
            method: 'get',
            url: 'static-pages',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(load_data.success === true) {
            
            this.props.internal.setDataForTable(load_data.data)
           
        }
        this.setState({loading: false})
    }

    createNewStaticPage = () => {
        
        this.props.internal.pushRoute("/static_pages/new")
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else  {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
        // this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key && queries[key] !== "") {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadStaticPages();
    }

    handleDelete = async () => {
        let id = toJS(this.props.internal.actionDeleteObj.id)
        let delete_static_page = await api({
            method: 'delete',
            url: `static-pages/${id}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_static_page.success === true) {
            this.props.internal.setSnackbar(delete_static_page.data.message, true)
            this.loadStaticPages();
            this.props.internal.setActionDelete();
        }
        else {
            let resultError = "";
            if(delete_static_page.data.data.errors) {
                for(let error in delete_static_page.data.data.errors){
                    resultError += delete_static_page.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    handleChangeShop = shop_id => {
        this.setState({shop_id: shop_id.target.value})
        this.addQueryToUrl("shop_id", shop_id.target.value)
    }

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions.static_pages);
        return (
            this.state.loading ?
                <CircularProgress className={'circular-progress'} />
                :
                <div  className={'static-pages-list'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.STATIC_PAGES.DELETE_STATIC_PAGE_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.PRIVILEGES.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                        {permissions.store ?
                            <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                                title={this.props.translate.i18n.MODULES.STATIC_PAGES.CREATE_NEW_STATIC_PAGE}
                                onClick={this.createNewStaticPage}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    {/* <MuiThemeProvider theme={theme}>
                        <FormControl className="select-type-position">
                            <InputLabel
                                htmlFor="select-shop"
                                className={"label-select-type"}
                                // shrink={true}
                            >
                                {this.props.translate.i18n.MODULES.MENU.SHOP}
                            </InputLabel>
                            <Select
                                classes={{
                                    root: "",
                                }}
                                value={this.state.shop_id}
                                onChange={this.handleChangeShop}
                                inputProps={{
                                    name: "select-shop",
                                    id: "select-shop",
                                }}
                                // displayEmpty
                            >
                                {toJS(this.props.internal.dataForTable.lists.shops).map((shop, index) => {
                                    return (<MenuItem key={index} value={shop.id}>{shop.name}</MenuItem>);
                                })}
                            </Select>
                        </FormControl>
                    </MuiThemeProvider> */}
                    <CustomTable
                        dropDownMenuItems = {this.dropDownMenuItems}
                        module = {'/static_pages'}
                        handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                        handleChangePage = {this.handleChangePage}
                        handleSort = {this.handleSort}
                        header = {this.tableHeader}
                        body = {this.tableBody}
                    />
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/static_pages/index.js